import type { ActivatedRouteSnapshot } from '@angular/router'
import { BaseRouteReuseStrategy } from '@angular/router'

export class CustomRoutesReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return (
      future.routeConfig === curr.routeConfig ||
      (future.component === curr.component && !!curr.routeConfig?.data?.reusable)
    )
  }
}
